import * as React from 'react';
import type { IconProps } from '@components/atoms/Icon/icon-prop-types';
import { IconSizes } from '@components/atoms/Icon/icon-prop-types';

export const CrossCountryColored = ({ size = 'xsmall' }: IconProps) => {
    return (
        <svg
            width={IconSizes[size]}
            height={IconSizes[size]}
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
            className="icon-freeform"
        >
            <g id="Cross-Country" fill="none" fillRule="evenodd">
                <path d="M0 0h24v24H0z" />
                <path
                    d="M9.975 7.317c1.158 1.137 2.892 1.546 4.472 1.056l1.185-.367c.556-.172 1.126.223 1.126.78v4.21c0 2.06 1.099 3.977 2.916 5.09l.746.905c.432.257-2.602 1.147-4.788 0-3.293-1.727-4.912-4.165-6.639-5.762-3.423-3.167-4.975-5-4.741-5.223l3.079-3.5c.49-.469.809-.961.964-.315l.076.315a5.87 5.87 0 0 0 1.604 2.811z"
                    fill="#FD8259"
                />
                <path
                    d="M21 20.552c0 .238-.225.432-.5.432h-4.292c-1.326 0-2.623-.512-3.558-1.405L3.131 10.48a.392.392 0 0 1-.001-.583l.551-.527 9.776 9.344a4.512 4.512 0 0 0 3.135 1.245h4.325c.048.05.083.106.083.17v.423zM14.521 9.683l.804-.249v3.505c0 1.967.907 3.79 2.458 5.019h-1.191a2.559 2.559 0 0 1-1.754-.691L5.129 7.986 7.741 5.49a6.347 6.347 0 0 0 1.717 2.988v.001c1.324 1.301 3.261 1.764 5.063 1.204zm7.37 8.505-2.392-1.467c-1.361-.834-2.174-2.248-2.174-3.782V9.104c0-.556-.26-1.065-.712-1.398-.069-.052-.147-.087-.223-.128a3.97 3.97 0 0 1 1.153-2.04l2.935-2.806a1.002 1.002 0 0 0 .032-1.415.998.998 0 0 0-1.413-.032L16.162 4.09a6.007 6.007 0 0 0-1.804 3.548l-.43.134c-1.078.335-2.282.05-3.068-.72a4.346 4.346 0 0 1-1.187-2.083l-.069-.287a1.744 1.744 0 0 0-.333-.662l1.349-1.297A1 1 0 1 0 9.233 1.28L6.586 3.826 1.748 8.45a2.393 2.393 0 0 0 .001 3.478l9.491 9.071H5.276a1 1 0 0 0 0 2.002l15.224-.014c1.379 0 2.5-1.092 2.5-2.434v-.424a2.28 2.28 0 0 0-1.109-1.94z"
                    fill="#0D0E0F"
                />
            </g>
        </svg>
    );
};
